<div id="landingPageContainer">
        <img class="logoWhite" src="assets/images/logosHabana/logo_habana_blanco.png" alt="" width="150px">
        <div id="landingPage" class="container">
                <h1 class="text-white">{{ 'landingPage.title' | translate }}</h1>
                <h2 class="text-white">{{ 'landingPage.subTitle' | translate }}</h2>
                <div id="landingBorder"></div>
        </div>
</div>